import React from 'react'
import { AiFillLinkedin, AiOutlineGithub } from 'react-icons/ai'
function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="py-4 mt-[50px] text-gray-400">
      <div className="flex justify-center items-center gap-[15px] text-[25px] mb-[15px]">
        <a href="https://linkedin.com/in/habib-meheraj" target="_blank"><AiFillLinkedin /></a>
        <a href="https://github.com/hr-meheraj?tab=repository" target="_blank"><AiOutlineGithub /></a> 
      </div>
      <div className="bottom text-center font-[18px]">
        &copy; Copyright {new Date().getFullYear()} All right reserved by Hr Meheraj
      </div>
  </footer>
  )
}
export default Footer